import * as React from 'react';

import axios from 'axios';
import _ from 'lodash'
import { Form } from 'react-bootstrap'
import InputAutoComplete, { IInputAutoCompleteHookProps } from '../InputAutoComplete/InputAutoComplete';
import GoogleApi from '../../utils/GoogleApi';
import config from '../../constants/config';
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";




const keyGenerator = () => (
    Math.random().toString(36).substr(2, 10)
);

const withQuery = (url, params = {}) => {
    const esc = encodeURIComponent
    let query = Object.keys(params)
        .filter(key => params[key] !== '' && params[key] !== null)
        .map(key => `${esc(key)}=${esc(params[key])}`)
        .join('&')
    query = query.length > 0 ? `?${query}` : null

    return `${url}${query}`
}

const colors = {
    red: "#cc0000",
    green: "#198c19",
}
const initError = {
    msg: "",
    show: false,
    status: null,
}

export interface AddressDetails {
    id: string
    verbose_address: string
    longitude: number
    latitude: number
    addressCountry: string
    addressState: string
}
const omitProps = [
    'query',
    'apiKey',
    'idAddresss',
    'textFeedBack',
    'textValue',
    'validated',
    // Event listeners
    "onPress",
    "onChangeText",
];
export interface IGoogleMapAutoCompleteProps extends IInputAutoCompleteHookProps {
    query?: {
        country: string
    }
    apiKey: string
    textFeedBack?: string
    textValue?: string
    validated?: boolean
    idAddresss?: string
    onPress?(addressDetails: AddressDetails): void
    onChangeText?(value: string): void
}

const GoogleMapAutoComplete: React.FC<IGoogleMapAutoCompleteProps> = (props): JSX.Element => {

    const [currentTextValue, setCurrentTextValue] = React.useState("")

    const [location, setLocation] = React.useState(null)
    const [error, setError] = React.useState(initError)
    const [currentValidated, setCurrentvalidated] = React.useState(false)


    //const inputAutoComplete = React.useRef(null)

    React.useEffect(() => {
        console.log("props.textValue", props.textValue)
        setCurrentTextValue(props.textValue)
    }, [props.textValue])

    React.useEffect(() => {
        setCurrentvalidated(props.validated)
        if (props.validated === true) {
            checkValidity()
        }
    }, [props.validated])



    React.useEffect(() => {
        if (props?.onPress && location) {
            /**
             * important for force update 
             */
            props.onPress(location)
        }
    }, [location]);

    const onPlaceSelected = (place) => {

        const addressDetails = parseAddress(place)
        setCurrentTextValue(addressDetails?.verbose_address)
        // hide list display 
        setLocation(addressDetails)
        // if (props.onPress) {
        //     props.onPress(addressDetails)
        // }
    }


    const parseAddress = (place) => {
        const addressComponents = _.isArray(place?.address_components) ? place?.address_components : []
        const address = {
            id: props.idAddresss,
            longitude: Number(place?.geometry?.location?.lng()),
            latitude: Number(place?.geometry?.location?.lat()),
            verbose_address: place?.formatted_address,
            streetNumber: null,
            street: null,
            neighborhood: null,
            city: null,
            county: null,
            addressCountry: null,
            addressState: null,
            zip: null,
        }

        addressComponents.forEach(component => {
            let { long_name, types } = component

            if (types.includes('street_number')) {
                address.streetNumber = long_name
            } else if (types.includes('route')) {
                address.street = long_name
            } else if (types.includes('neighborhood')) {
                address.neighborhood = long_name
            } else if (types.includes('locality')) {
                address.city = long_name
            } else if (types.includes('administrative_area_level_2')) {
                address.county = long_name
            } else if (types.includes('administrative_area_level_1')) {
                address.addressState = long_name
            } else if (types.includes('country')) {
                address.addressCountry = long_name
            } else if (types.includes('postal_code')) {
                address.zip = long_name
            }
        })

        return address
    }


    const checkValidity = () => {
        setError(validation(location))
    }

    const validation = (location) => {
        let error = {
            msg: "",
            show: false,
            status: false,
        }
        if (props.required) {
            if (location == null || location.verbose_address == undefined) {
                error.show = true;
                error.msg = props.textFeedBack
                return error
            }

            if (props.textValue == "" || props.textValue != location.verbose_address) {
                error.show = true;
                error.msg = props.textFeedBack
                return error
            }

        }

        return error
    }

    const onPlaceSelectedCallback = React.useCallback((place) => {
        return onPlaceSelected(place)
    }, [props?.textValue]);

    const { ref } = usePlacesWidget({
        apiKey: config.keyMap,
        onPlaceSelected: onPlaceSelectedCallback,
        options: {
            types: ["address"],
            componentRestrictions: { country: "us" },

        },

        // googleCallbackName
    });
    return (
        <React.Fragment>
            <input
                placeholder={props?.placeholder}
                className='form-control input-material'
                ref={ref}
                style={{}}
                onChange={(event) => {
                    console.log("onChangeInputAddress",)
                }}
                defaultValue={`${currentTextValue}`}

            />
            {/* <Autocomplete
                className='form-control input-material'
                style={{ width: "250px" }}
                id="countryAnother"
                placeholder="countryAnother"
                // value={`${props?.textValue}`}
                apiKey={config.keyMap}
                onPlaceSelected={(place) =>
                    onPlaceSelected(place)
                }
                onChange={() => {

                }}
            /> */}
            {/* {_renderSelected(selectedRow)} */}
            {/* <InputAutoComplete
                {..._.omit(props, omitProps)}
                searchData={fetchSearch}
                textValue={`${currentTextValue}`}
                onChange={onChangeSearch}
                // listViewDisplay={listViewDisplay}
                stopSearching={isSearched}
                renderRow={renderRowSearch}
            /> */}

        </React.Fragment>
    )


}
//countryes  aa, ad, ae, af, ag, ai, al, am, ao, aq, ar, as, at, au, aw, ax, az, ba, bb, bd, be, bf, bg, bh, bi, bj, bl, bm, bn, bo, bq, br, bs, bt, bv, bw, by, bz, ca, cc, cd, cf, cg, ch, ci, ck, cl, cm, cn, co, cr, cu, cv, cw, cx, cy, cz, de, dj, dk, dm, do, dz, ec, ee, eg, eh, er, es, et, fi, fj, fk, fm, fo, fr, ga, gb, gd, ge, gf, gg, gh, gi, gl, gm, gn, gp, gq, gr, gs, gt, gu, gw, gy, hk, hm, hn, hr, ht, hu, id, ie, il, im, in, io, iq, ir, is, it, je, jm, jo, jp, ke, kg, kh, ki, km, kn, kp, kr, kw, ky, kz, la, lb, lc, li, lk, lr, ls, lt, lu, lv, ly, ma, mc, md, me, mf, mg, mh, mk, ml, mm, mn, mo, mp, mq, mr, ms, mt, mu, mv, mw, mx, my, mz, na, nc, ne, nf, ng, ni, nl, no, np, nr, nu, nz, om, pa, pe, pf, pg, ph, pk, pl, pm, pn, pr, ps, pt, pw, py, qa, re, ro, rs, ru, rw, sa, sb, sc, sd, se, sg, sh, si, sj, sk, sl, sm, sn, so, sr, ss, st, sv, sx, sy, sz, tc, td, tf, tg, th, tj, tk, tl, tm, tn, to, tr, tt, tv, tw, tz, ua, ug, um, us, uy, uz, va, vc, ve, vg, vi, vn, vu, wf, ws, xx, xy, ye, yt, yy, za, zm, zw, zz, -1, qq, dg, xk"
GoogleMapAutoComplete.defaultProps = {
    className: "",
    placeholder: "Enter a location",
    query: {
        country: "us",

    },
    required: false,
    textFeedBack: 'required.',
    validated: null,
}
export default GoogleMapAutoComplete;
export { GoogleMapAutoComplete };